import React, { forwardRef } from 'react';

export const GlassInput = forwardRef(({
  label,
  value,
  onChange,
  placeholder = '',
  type = 'text',
  multiline = false,
  rows = 1,
  error = null,
  disabled = false,
  prefix = null,
  suffix = null,
  className = '',
  ...props
}, ref) => {
  const inputProps = {
    ref,
    value,
    onChange: (e) => onChange?.(e.target.value),
    placeholder,
    disabled,
    className: `glass-input ${error ? 'error' : ''} ${className}`,
    ...props,
  };

  const InputComponent = multiline ? 'textarea' : 'input';
  
  const inputElement = multiline ? (
    <textarea {...inputProps} rows={rows} />
  ) : (
    <input {...inputProps} type={type} />
  );

  if (!label && !prefix && !suffix) {
    return inputElement;
  }

  return (
    <div className="glass-input-wrapper">
      {label && <label className="glass-input-label">{label}</label>}
      <div className="glass-input-control">
        {prefix && <span className="prefix">{prefix}</span>}
        {React.cloneElement(inputElement, {
          className: `${inputElement.props.className} ${prefix ? 'has-prefix' : ''} ${suffix ? 'has-suffix' : ''}`,
        })}
        {suffix && <span className="suffix">{suffix}</span>}
      </div>
      {error && <div className="glass-input-error">{error}</div>}
    </div>
  );
});

GlassInput.displayName = 'GlassInput';